import classNames from 'classnames'

import './SnackbarContent.scss'

export type SnackbarAction = { label: string, onClick: () => void }
export type SnackbarContentType = 'success' | 'warning' | 'error' | 'info'

type SnackbarContentProps = {
	title: string,
	description?: string,
	type: SnackbarContentType,
	action?: SnackbarAction
}

const SnackbarContent = ( { title, description, type, action }: SnackbarContentProps ) => (
	<div className="SnackbarContent">
		<div className="SnackbarContent__header">
			<span className={classNames( 'SnackbarContent__title', `SnackbarContent__title--${type}` )}>
				{title}
			</span>
			{action && (
				<button
					type="button"
					className="SnackbarContent__action"
					onClick={action.onClick}
				>
					{action.label}
				</button>
			)}
		</div>
		{description && <span className="SnackbarContent__description">{description}</span>}
	</div>
)

export default SnackbarContent
